export default __webpack_public_path__ + "static/media/mobile_home_add_sm_icon.1fe589c3.svg";